var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "content-area__content login",
      class: { embedded: _vm.inFrame }
    },
    [
      _c("vue-title", {
        attrs: { title: _vm.$t("identityProvider:login:title") }
      }),
      _vm._v(" "),
      _vm.isActiveDTM
        ? _c(
            "div",
            {
              staticClass: "downtime-container",
              attrs: {
                id: "downtime-message-container",
                role: "alert",
                "data-test-element": "active-downtime-message"
              }
            },
            [
              _c("span", { staticClass: "active-downtime-message" }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons notification-icon",
                    attrs: {
                      "data-test-element": "downtime-message-notification"
                    }
                  },
                  [_vm._v("notifications")]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "message-label",
                    attrs: { "data-test-element": "downtime-message-label" }
                  },
                  [_vm._v(_vm._s(_vm.model.activeDowntimeMessage))]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("bulletin-component", { ref: "bulletin" }),
      _vm._v(" "),
      !_vm.inFrame
        ? _c("h1", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("identityProvider:login:title")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "form",
          attrs: { action: "authentication" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.validateBeforeSubmit.apply(null, arguments)
            }
          }
        },
        [
          _vm.model.showError && !_vm.errors.any()
            ? _c(
                "div",
                {
                  staticClass:
                    "validation-summary-errors alert alert-danger fade show",
                  attrs: {
                    role: "alert",
                    "data-valmsg-summary": "true",
                    "data-test-element": "idp-alert-danger-generic"
                  }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("warning")
                  ]),
                  _vm._v(" "),
                  _vm.model.errorMessage
                    ? _c("span", [_vm._v(_vm._s(_vm.model.errorMessage))])
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "identityProvider:login:genericError",
                              null,
                              [
                                this.$t("identityProvider:tenant:supportName"),
                                this.$t(
                                  "identityProvider:tenant:customerServicePhoneNumber"
                                )
                              ]
                            )
                          )
                        )
                      ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.any(),
                  expression: "errors.any()"
                }
              ],
              staticClass:
                "validation-summary-errors alert alert-danger fade show",
              attrs: {
                role: "alert",
                "data-valmsg-summary": "true",
                "data-test-element": "idp-alert-danger-validation"
              }
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("error")]),
              _vm._v(" "),
              _vm.errors.has(".")
                ? _c("span", [_vm._v(_vm._s(_vm.errors.first(".")))])
                : _c(
                    "span",
                    {
                      staticClass: "alert-message",
                      attrs: { "data-test-element": "alert-message" }
                    },
                    [_vm._v(_vm._s(_vm.$t("validation:summary")))]
                  )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "panel login" }, [
            _c("div", { staticClass: "login-form-controls" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("shared:fields:username")))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.model.username,
                        expression: "model.username"
                      },
                      { name: "focus", rawName: "v-focus" },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "control",
                    class: {
                      "input-validation-error": _vm.hasErrorOn("Username")
                    },
                    attrs: {
                      name: "Username",
                      "data-test-element": "Username",
                      "data-vv-as": _vm.$t("shared:fields:username"),
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.model.username },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.model, "username", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasErrorOn("Username"),
                        expression: "hasErrorOn('Username')"
                      }
                    ],
                    staticClass: "field-validation-error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("Username")))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("shared:fields:password")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "password-container" }, [
                    (_vm.showPassword ? "text" : "password") === "checkbox"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.password,
                              expression: "model.password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "control",
                          class: {
                            "input-validation-error": _vm.hasErrorOn("Password")
                          },
                          attrs: {
                            name: "Password",
                            "data-test-element": "Password",
                            "data-vv-as": _vm.$t("shared:fields:password"),
                            autocomplete: "off",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.model.password)
                              ? _vm._i(_vm.model.password, null) > -1
                              : _vm.model.password
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.model.password,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.model,
                                      "password",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.model,
                                      "password",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.model, "password", $$c)
                              }
                            }
                          }
                        })
                      : (_vm.showPassword ? "text" : "password") === "radio"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.password,
                              expression: "model.password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "control",
                          class: {
                            "input-validation-error": _vm.hasErrorOn("Password")
                          },
                          attrs: {
                            name: "Password",
                            "data-test-element": "Password",
                            "data-vv-as": _vm.$t("shared:fields:password"),
                            autocomplete: "off",
                            type: "radio"
                          },
                          domProps: {
                            checked: _vm._q(_vm.model.password, null)
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.model, "password", null)
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.password,
                              expression: "model.password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "control",
                          class: {
                            "input-validation-error": _vm.hasErrorOn("Password")
                          },
                          attrs: {
                            name: "Password",
                            "data-test-element": "Password",
                            "data-vv-as": _vm.$t("shared:fields:password"),
                            autocomplete: "off",
                            type: _vm.showPassword ? "text" : "password"
                          },
                          domProps: { value: _vm.model.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.model,
                                "password",
                                $event.target.value
                              )
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "toggle-password",
                        on: { click: _vm.togglePasswordVisibility }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(
                            _vm._s(
                              _vm.showPassword ? "visibility" : "visibility_off"
                            )
                          )
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasErrorOn("Password"),
                        expression: "hasErrorOn('Password')"
                      }
                    ],
                    staticClass: "field-validation-error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("Password")))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: {
                      type: "submit",
                      id: "logonButton",
                      disabled: _vm.disabled
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("identityProvider:login:submit")))]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "other-actions login" }, [
              _vm.model.enrollUrlEnabled
                ? _c("div", { staticClass: "action" }, [
                    _c("div", { staticClass: "prompt" }, [
                      _vm._v(
                        _vm._s(_vm.$t("identityProvider:login:enrollPrompt"))
                      )
                    ]),
                    _vm._v(" "),
                    _vm.model.enrollUrl && !_vm.isActiveDTM
                      ? _c(
                          "a",
                          {
                            staticClass: "link",
                            attrs: {
                              "data-test-element": "enroll-user",
                              href: _vm.model.enrollUrl
                            },
                            on: { click: _vm.clickedLink }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("identityProvider:login:enroll"))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isActiveDTM
                      ? _c(
                          "span",
                          {
                            staticClass: "link disable-links",
                            attrs: { "data-test-element": "enroll-user" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("identityProvider:login:enroll"))
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.model.forgottenPasswordEnabled
                ? _c("div", { staticClass: "action" }, [
                    _c("div", { staticClass: "prompt" }, [
                      _vm._v(_vm._s(_vm.forgottenPasswordPrompt))
                    ]),
                    _vm._v(" "),
                    _vm.model.forgottenPasswordUrl && !_vm.isActiveDTM
                      ? _c(
                          "a",
                          {
                            staticClass: "link",
                            attrs: {
                              "data-test-element": "reset-pass",
                              href: _vm.model.forgottenPasswordUrl
                            },
                            on: { click: _vm.clickedLink }
                          },
                          [_vm._v(_vm._s(_vm.forgottenPasswordLink))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isActiveDTM
                      ? _c(
                          "span",
                          {
                            staticClass: "link disable-links",
                            attrs: { "data-test-element": "reset-pass" }
                          },
                          [_vm._v(_vm._s(_vm.forgottenPasswordLink))]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.model.showLanguagePreference
                ? _c("div", { staticClass: "action" }, [
                    _c(
                      "a",
                      {
                        staticClass: "switchLanguage link",
                        attrs: {
                          "data-test-element": "idp-switchLanguage",
                          href: "authentication/SwitchLanguage"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.switchLanguage.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("shared:action:switchLanguage")))]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-613cd519", { render: render, staticRenderFns: staticRenderFns })
  }
}